import { DecimalPipe } from "@angular/common";

export class UsersType {
    AndroidUsers:number;
    IOSUsers:number;
    OtherUsers:number;
}

